import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import MidBox from '../components/Boxes/MidBox'
import Network from '../utils/Network'
import { motion } from 'framer-motion'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import TipList from '../components/TipList'
import Button from '../components/Button'
import { isMobile } from 'react-device-detect'
import { Helmet } from 'react-helmet'
import { useAppTranslation } from '../i18n/useAppTranslation'


type Props = {}


const DAO = (props: Props) => {
    const { t } = useAppTranslation(["dao", "common"])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const axios = new Network()
    const navigate = useNavigate()
    const getPolls = async () => {
        setLoading(true)
        const response = await axios.CallApi({
            url: '/poll/search',
            secApi: true,
            method: 'get'
        })
        setData(response.results)
        setLoading(false)
    }

    useEffect(() => {
        getPolls()
    }, [])
    return (
        <SkeletonTheme baseColor='#3e382b' highlightColor='#474132'>
            <Helmet>
                <title key={'title'}>
                    {t("dao:meta.title")}
                </title>
            </Helmet>
            <motion.div
                exit={{ opacity: 0, y: 200 }}
                transition={{ duration: 0.4 }} className='row' initial={isMobile ? undefined : { opacity: 0, y: 200 }} animate={{ opacity: 1, y: 0 }} >
                <MidBox modal title={t("dao:polls.title")}>

                    <div style={{ overflow: 'auto' }} className="pe-1 pt-3 pb-5 ps-1 pe-sm-3 ps-sm-3 pb-4 table-box">
                        <table className="table table-borderless m-0 text-white" > <thead>
                            <tr>
                                <th scope="col">{t("dao:polls.table.pollTitle")}</th>
                                <th scope="col">{t("dao:polls.table.startDate")}</th>
                                <th scope="col">{t("dao:polls.table.endDate")}</th>

                                <th scope="col">{t("dao:polls.table.status")}</th>
                                <th >

                                </th>
                            </tr>
                        </thead>
                            <tbody>
                                {loading && [1, 2, 3].map((item) =>
                                    <tr key={"loading" + item} className='pointer'
                                    >
                                        <td width={"50%"}>
                                            <Skeleton width={'100%'} />
                                        </td>
                                        <td> <Skeleton width={'60px'} /> </td>
                                        <td> <Skeleton width={'60px'} /></td>
                                        <td >
                                            <Skeleton width={'100px'}
                                                height={25}
                                            />
                                        </td>

                                    </tr>
                                )}
                                {!loading && data?.map((item, key) => (
                                    <>

                                        <tr className='pointer'
                                            onClick={() => navigate(`/dao/${item._id}`)}
                                            key={"row" + key}>
                                            <td style={{ minWidth: 200 }}><span
                                                className='fs-big'
                                            >
                                                {item?.title}</span></td>
                                            <td>{moment(new Date(item?.startDate)).format('MM/DD/YYYY')} </td>
                                            <td>{moment(new Date(item?.endDate)).format('MM/DD/YYYY')}</td>
                                            <td width={100} >
                                                <div style={{
                                                    padding: '8px 13px',
                                                    width: 'fit-content',
                                                    borderRadius: 50,
                                                    backgroundColor: new Date(item?.startDate).getTime() > Date.now() ? 'var(--theme-color-blue)' :
                                                        new Date(item?.endDate).getTime() < Date.now() ? 'var(--theme-color-red)' : 'var(--theme-color-green)'
                                                }} className=''>
                                                    {
                                                        new Date(item?.startDate).getTime() > Date.now()
                                                            ? t("dao:polls.status.upcoming")
                                                            : new Date(item?.endDate).getTime() < Date.now()
                                                                ? t("dao:polls.status.ended")
                                                                : t("dao:polls.status.active")
                                                    }
                                                </div>
                                            </td>
                                            <td >
                                                <Button variant='default'>
                                                    {t("common:actions.open")}
                                                </Button>
                                            </td>
                                        </tr>
                                        {isMobile && <tr>
                                            <td>
                                                <Button
                                                    onClick={() => navigate(`/dao/${item._id}`)}
                                                    variant='default'>
                                                    {t("common:actions.open")}
                                                </Button>
                                            </td>
                                        </tr>
                                        }
                                    </>
                                ))}

                            </tbody></table>
                    </div>
                </MidBox>
            </motion.div>
            <motion.div exit={{ opacity: 0, y: 200 }}
                transition={{ duration: 0.4 }} className='row' initial={isMobile ? undefined : { opacity: 0, y: 200 }} animate={{ opacity: 1, y: 0 }}>
                <p>
                    {t("dao:intro.paragraph1Line1")}<br />
                    {t("dao:intro.paragraph1Line2")}

                </p>

                <p> {t("dao:intro.paragraph2")}
                </p>
                <br />


                <TipList
                    item={[
                        t("dao:voteRules.0"),
                        t("dao:voteRules.1"),
                        t("dao:voteRules.2"),
                        t("dao:voteRules.3"),
                        t("dao:voteRules.4"),
                        t("dao:voteRules.5"),
                        t("dao:voteRules.6"),
                        t("dao:voteRules.7"),
                        t("dao:voteRules.8")
                    ]}
                    icon="/assets/images/icons/icon-dart.png"
                />

            </motion.div>
        </SkeletonTheme>
    )
}

export default DAO
